import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationUpdatedTemplates = [
  {
    id: '-118001',
    language: Language.EN,
    subject: 'Exceptional charge or service update',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: {{getLeaseVariousType lvo language}} update on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Updated details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Amount: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Comment: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Start date: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duration: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Frequency: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-118002',
    language: Language.FR,
    subject: "Mise à jour d'une charge exceptionnelle ou d'un service",
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        <p>Concerne: mise à jour d'un service relatif au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{else}}
        <p>Concerne: mise à jour d'une charge exceptionnelle relative au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{/if}}
        <p></p>
        <p>Nouveaux détails:</p>
        <ul>
        <li>Libellé: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Montant: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Commentaire: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Date de début: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Durée: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Fréquence: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-118003',
    language: Language.NL,
    subject: 'Uitzonderlijke last of dienst update',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: update van een {{getLeaseVariousType lvo language}} op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nieuwe details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Bedrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Opmerking: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Begindatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duur: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Betaling frequentie: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-118004',
    language: Language.DE,
    subject: 'Aktualisierung einer außergewöhnlichen Gebühr oder Dienstleistung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_UPDATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        <p>Betreff: Aktualisierung einer Dienstleistung für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{else}}
        <p>Betreff: Aktualisierung einer außergewöhnlichen Gebühr für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{/if}}
        <p></p>
        <p>Aktualisierte Details:</p>
        <ul>
        <li>Bezeichnung: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Betrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Kommentar: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Startdatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Dauer: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Häufigkeit: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
